import type { LocalizedText } from "@/mocks/articles";

export interface HomeFaq {
  question: LocalizedText;
  answer: LocalizedText;
}

export const homeFaqs: HomeFaq[] = [
  {
    question: {
      en: "What is the USFans Spreadsheet?",
      pl: "Czym jest USFans Spreadsheet?",
      es: "¿Qué es el USFans Spreadsheet?",
      fr: "Qu'est-ce que la feuille USFans Spreadsheet ?",
    },
    answer: {
      en: "It is an organized reference that gathers product categories and seller links in one place, so you can jump straight to the products you want on the main store.",
      pl: "To uporządkowane źródło, które gromadzi kategorie produktów i linki do sprzedawców w jednym miejscu, dzięki czemu możesz przejść prosto do wybranych produktów w głównym sklepie.",
      es: "Es una referencia organizada que reúne categorías de productos y enlaces de vendedores en un solo lugar, para que vayas directo a los productos que quieres en la tienda principal.",
      fr: "C'est une référence organisée qui rassemble les catégories de produits et les liens des vendeurs au même endroit, pour accéder directement aux produits souhaités sur la boutique principale.",
    },
  },
  {
    question: {
      en: "Do the category buttons cost anything to use?",
      pl: "Czy przyciski kategorii są płatne?",
      es: "¿Cuestan algo los botones de categoría?",
      fr: "Les boutons de catégorie sont-ils payants ?",
    },
    answer: {
      en: "No. Browsing categories and guides is free. You only pay when you choose to buy something on the main store.",
      pl: "Nie. Przeglądanie kategorii i poradników jest bezpłatne. Płacisz tylko wtedy, gdy zdecydujesz się coś kupić w głównym sklepie.",
      es: "No. Explorar categorías y guías es gratis. Solo pagas cuando decides comprar algo en la tienda principal.",
      fr: "Non. Parcourir les catégories et les guides est gratuit. Vous ne payez que lorsque vous choisissez d'acheter sur la boutique principale.",
    },
  },
  {
    question: {
      en: "Where do the links lead?",
      pl: "Dokąd prowadzą linki?",
      es: "¿A dónde llevan los enlaces?",
      fr: "Où mènent les liens ?",
    },
    answer: {
      en: "Each category and button links to a dedicated page on the main store, kaspreadsheet.com, where the actual products are listed.",
      pl: "Każda kategoria i przycisk prowadzi do dedykowanej strony w głównym sklepie, kaspreadsheet.com, gdzie znajdują się rzeczywiste produkty.",
      es: "Cada categoría y botón enlaza a una página dedicada de la tienda principal, kaspreadsheet.com, donde se listan los productos reales.",
      fr: "Chaque catégorie et bouton renvoie vers une page dédiée de la boutique principale, kaspreadsheet.com, où sont listés les produits réels.",
    },
  },
  {
    question: {
      en: "Is this the official USFans website?",
      pl: "Czy to oficjalna strona USFans?",
      es: "¿Es este el sitio oficial de USFans?",
      fr: "Est-ce le site officiel d'USFans ?",
    },
    answer: {
      en: "No. This is an independent informational resource. It is not the official USFans website and is not affiliated with it.",
      pl: "Nie. To niezależne źródło informacji. Nie jest to oficjalna strona USFans i nie jest z nią powiązane.",
      es: "No. Este es un recurso informativo independiente. No es el sitio oficial de USFans ni está afiliado a él.",
      fr: "Non. Il s'agit d'une ressource d'information indépendante. Ce n'est pas le site officiel d'USFans et il n'y est pas affilié.",
    },
  },
];